"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSafeCall = exports.addTimeout = void 0;
function addTimeout(promise, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.timeout, timeout = _c === void 0 ? 2 * 60 * 1000 : _c, _d = _b.message, message = _d === void 0 ? 'Timeout: Wix Js Sdk' : _d;
    var error;
    try {
        throw new Error(message); // to capture stack trace for IE
    }
    catch (ex) {
        error = ex;
    }
    var timerId;
    var timeoutPromise = new Promise(function (resolve, reject) {
        timerId = setTimeout(reject, timeout, error);
    });
    var clear = function () { return clearTimeout(timerId); };
    promise.then(clear, clear);
    return Promise.race([promise, timeoutPromise]);
}
exports.addTimeout = addTimeout;
function createSafeCall(onError) {
    return function (fn) {
        return function () {
            try {
                return fn.apply(this, arguments); //tslint:disable-line:no-invalid-this
            }
            catch (ex) {
                onError(ex);
                return null;
            }
        };
    };
}
exports.createSafeCall = createSafeCall;
//# sourceMappingURL=utils.js.map